import { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./authprovider"; // Import the useAuth hook
import Swal from "sweetalert2";

function AutoLogout() {
  const navigate = useNavigate();
  const logoutDuration = 15 * 60 * 1000; // 15 minutes in milliseconds
  const { logout } = useAuth(); // Destructure the logout function from useAuth

  const setLogoutTime = useCallback(() => {
    const logoutTime = Date.now() + logoutDuration;
    localStorage.setItem("logoutTime", logoutTime);
  }, [logoutDuration]);

  const resetTimeout = useCallback(() => {
    setLogoutTime();
  }, [setLogoutTime]);

  const checkTimeout = useCallback(() => {
    const logoutTime = localStorage.getItem("logoutTime");
    if (logoutTime && Date.now() >= logoutTime) {
      Swal.fire({
        icon: "error",
        title: "session end",
        showConfirmButton: true,
      }).then(() => {
        logout(); // Call the logout function from useAuth to clear user data
        navigate("/login"); // Redirect to login page
      });
    }
  }, [logout, navigate]);

  const logRemainingTime = useCallback(() => {
    const logoutTime = localStorage.getItem("logoutTime");
    if (logoutTime) {
      // const remainingTime = (logoutTime - Date.now()) / 1000;
      // console.log("Remaining time:", remainingTime, "seconds");
    }
  }, []);

  useEffect(() => {
    setLogoutTime();

    const interval = setInterval(logRemainingTime, 1000);
    const timeoutChecker = setInterval(checkTimeout, 1000);

    window.addEventListener("mousemove", resetTimeout);
    window.addEventListener("keypress", resetTimeout);
    window.addEventListener("click", resetTimeout);
    window.addEventListener("scroll", resetTimeout);

    return () => {
      clearInterval(interval);
      clearInterval(timeoutChecker);
      window.removeEventListener("mousemove", resetTimeout);
      window.removeEventListener("keypress", resetTimeout);
      window.removeEventListener("click", resetTimeout);
      window.removeEventListener("scroll", resetTimeout);
    };
  }, [setLogoutTime, resetTimeout, checkTimeout, logRemainingTime]);

  return null; // AutoLogout component doesn't render anything
}

export default AutoLogout;
